import { differenceInMinutes, isToday, isYesterday } from "date-fns";
import { i18n } from "../translate/i18n";

export const isTypingPresence = (presence) =>
	presence === "typing" || presence === "recording";

const formatClock = (date) => {
	const hours = date.getHours();
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const hour12 = hours % 12 || 12;
	const suffix = hours < 12 ? "a.m." : "p.m.";
	return `${hour12}:${minutes} ${suffix}`;
};

export const formatLastSeenLabel = (lastSeen) => {
	if (!lastSeen) return "";
	const date = new Date(lastSeen < 1e12 ? lastSeen * 1000 : lastSeen);
	if (Number.isNaN(date.getTime())) return "";

	const minutes = Math.max(0, differenceInMinutes(new Date(), date));
	if (minutes < 60) {
		const count = Math.max(1, minutes);
		return count === 1
			? i18n.t("chatPresence.minuteAgo")
			: i18n.t("chatPresence.minutesAgo", { count });
	}
	if (isToday(date)) {
		return formatClock(date);
	}
	if (isYesterday(date)) {
		return i18n.t("chatPresence.yesterday");
	}
	return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};

export const formatChatPresenceLabel = (state) => {
	if (!state?.presence) return "";
	if (state.presence === "typing") return i18n.t("chatPresence.typing");
	if (state.presence === "recording") return i18n.t("chatPresence.recording");
	if (state.presence === "online" || state.presence === "paused") {
		return i18n.t("chatPresence.online");
	}
	if (state.presence === "offline" && state.lastSeen) {
		return formatLastSeenLabel(state.lastSeen);
	}
	return "";
};
